// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CreateTaskByAccountDisplayIdRequestModel {
    'accountDisplayId': string;
    'type': string;
    'subject'?: string;
    'body'?: string;
    'dueDate'?: Moment;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CreateTaskByAccountDisplayIdRequestModel>> = [
        {
            "name":     "accountDisplayId",
            "baseName": "accountDisplayId",
            "type":     "string"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
        {
            "name":     "subject",
            "baseName": "subject",
            "type":     "string"
        },
        {
            "name":     "body",
            "baseName": "body",
            "type":     "string"
        },
        {
            "name":     "dueDate",
            "baseName": "dueDate",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return CreateTaskByAccountDisplayIdRequestModel.attributeTypeMap;
    }
}
